import { RootState } from 'shared/types/RootState';

export const rootStateBranchSelector =
  <RootStateBranchName extends keyof RootState>(rootStateBranchName: RootStateBranchName) =>
  (state: RootState): RootState[RootStateBranchName] =>
    state[rootStateBranchName];
